import React from 'react';

export const Logo = ({ showSubtitle = true, size = 'default' }) => {
  const textSizes = {
    small: {
      main: 'text-xl md:text-2xl',
      subtitle: 'text-xs md:text-sm',
    },
    default: {
      main: 'text-2xl md:text-3xl',
      subtitle: 'text-sm md:text-base',
    },
    large: {
      main: 'text-3xl md:text-4xl',
      subtitle: 'text-base md:text-lg',
    },
  };

  const sizes = textSizes[size] || textSizes.default;

  return (
    <div data-testid="logo" className="flex flex-col items-center text-center">
      <h1 className={`font-heading font-bold tracking-wide ${sizes.main} text-navy-950`}>
        The Cash Flow Audit
      </h1>
      {showSubtitle && (
        <p className={`${sizes.subtitle} text-slate-600 font-medium mt-1`}>
          by Sanam Bawa | Everything Mortgages
        </p>
      )}
    </div>
  );
};

export const FooterLogo = () => {
  return (
    <div data-testid="footer-logo" className="flex flex-col items-center text-center">
      <span className="font-heading font-semibold text-base uppercase tracking-wider text-slate-600">
        Liquidity Audit
      </span>
      <span className="text-sm text-slate-500 mt-1">
        By Sanam Bawa | Everything Mortgages
      </span>
    </div>
  );
};
